import React, { useEffect, useRef, useState } from "react";
import { translate } from "react-polyglot";
import { Link } from "react-router";
import { isMobile } from 'lib/checkuseros';

import PropTypes from "prop-types";

import Button from "../button";

import LogoAnimation from "./assets/logo.json";
import LottieAnimation from "../ui/lottie-animation/LottiAnimation";

import "./styles.less";

const Header = ({ t, loginRedirectionURL, registrationRedirectionURL, splashScreenVisibilityStatus }) => {
  const [headerType, setHeaderType] = useState("basic");
  const cbRef = useRef(resizeHeaderOnScroll);
  const isMobileOS = isMobile()


  const resizeHeaderOnScroll = () => {
    const distanceY = window.pageYOffset || document.documentElement.scrollTop;
    const shrinkOn = 5;
    if (distanceY > shrinkOn && headerType !== "fixed")
      setHeaderType("fixed");
    else if (headerType !== "static" && distanceY < shrinkOn)
      setHeaderType("basic");
  };

  useEffect(() => {
    cbRef.current = resizeHeaderOnScroll;
  });

  useEffect(() => {
    const cb = (e) => cbRef.current(e);
    window.addEventListener("scroll", cb);
    return () => {
      window.removeEventListener("scroll", cb);
    };
  }, []);


  const handleRegistrationClick = () => {
    if (isMobileOS) {
      window.location.assign(`${window.location.origin}/redirects/checkos_redirect.html`);
      return;
    }

    window.location.assign(registrationRedirectionURL);
  };

  const handleLoginClick = () => {
    if (isMobileOS) {
      window.location.assign(`${window.location.origin}/redirects/checkos_redirect.html`);
      return;
    }

    window.location.assign(loginRedirectionURL);
  };

  return (
    <header
      className={`header__container header__container--${headerType}`}
    >
      <div className="header__inner-wrapper">
        <Link to="/">
          <LottieAnimation isVisible={!splashScreenVisibilityStatus} classname={"header__logo"} animationData={LogoAnimation} />
        </Link>

        <div className="header__controls">
          <div className="header__controls__registration-btn">
            <Button
              handleClick={handleRegistrationClick}
              size="sm"
              text={t("landing.header.registration")}
              isIcon={false}
              variant="default"
            />
          </div>
          <Button
            handleClick={handleLoginClick}
            size="sm"
            text={t("landing.header.login")}
            isIcon={false}
            variant="outline"
          />
        </div>
      </div>
    </header>
  );
};


Header.propTypes = {
  loginRedirectionURL: PropTypes.string.isRequired,
  registrationRedirectionURL: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default translate()(Header);



// WEBPACK FOOTER //
// ./src/js/components/pages/newLandingPage/header/index.js